import React from 'react';

import type { FactureContextType } from './FactureContext';

const FactureRejetContext = React.createContext<FactureContextType>({
  total: 0,
  factures: [],
  filters: [],
  search: '',
  sorts: {},
  setFactures: () => {},
  setFilters: () => {},
  setSearch: () => {},
  setSorts: () => {},
  setPage: () => {},
  setTotal: () => {},
  getFactures: () => {},
  applyDefaultFilters: () => {},
});

export default FactureRejetContext;
